// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2occe","label":"Category_label__pvyxr","content":"Category_content__3Q1r8","header":"Category_header__-CRYh","location":"Category_location__3Mdsj"};